module.exports = __webpack_public_path__ + "static/media/customAi.ab304695.svg";